import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

const PROMPT_MAX_LENGTH = 2000;

export function getGenerateTrainingValidation(t: TFunction) {
  return yup.object({
    prompt: yup
      .string()
      .max(
        PROMPT_MAX_LENGTH,
        t('formikValidation.maxLength').replace(
          '{0}',
          String(PROMPT_MAX_LENGTH),
        ),
      ),
    mainMuscleGroups: yup.array().default([]),
    categories: yup.array().default([]),
    equipments: yup.array().default([]),
    developedSkills: yup.array().default([]),
  });
}
